<template>
  <div>
    <Header :header="$t('BANNER_GROUPS')" :role="role" showSettings />
    <b-container class="container-wide compliance-banner-groups">
      <b-row class="mt-4" align-h="end">
        <b-col md="4">
          <b-btn
            variant="primary"
            size="md"
            block
            :to="{ name: 'CreateBannerGroup' }"
            exact
            >{{ $t('CREATE_BANNER_GROUP') }}</b-btn
          >
        </b-col>
      </b-row>
      <b-card class="mt-5">
        <b-table
          primary-key="id"
          outlined
          :items="bannerGroups"
          :fields="fields"
          class="mt-2"
          :busy="loading"
          responsive
        >
          <template #cell(description)="data">
            <div
              class="text-truncate cursor-pointer w-200"
              @click="e => e.target.classList.toggle('text-truncate')"
              role="button"
            >
              {{ data.value }}
            </div>
          </template>
          <template #cell(bannerCount)="row">
            {{ row.item.banners ? row.item.banners.length : 0 }}
          </template>
          <template #cell(actions)="row">
            <div class="actions">
              <router-link
                :to="`/compliance/banner-group/${row.item.id}/edit`"
                v-b-tooltip.hover
                :title="$t('EDIT')"
              >
                <img alt="edit" src="../../assets/edit-icon.svg" />
              </router-link>
              <span v-b-tooltip.hover :title="$t('DELETE')">
                <a @click="openDeleteModal(row.item.id)">
                  <img alt="delete" src="../../assets/delete-icon.svg" />
                </a>
              </span>
            </div>
          </template>
          <template #table-busy>
            <RenderSpinner :fixed="false" />
          </template>
        </b-table>
        <RenderDeleteModal
          :show="showDeleteModal"
          @ok="closeDeleteModal(true)"
          @cancel="closeDeleteModal()"
          :label="$t('ARE_YOU_SURE_DELETE_BANNER_GROUP')"
        />
      </b-card>
    </b-container>
  </div>
</template>

<script>
import { Header, RenderDeleteModal, RenderSpinner } from '@/components/common';
import { mapState } from 'vuex';

export default {
  name: 'ManageBannerGroups',
  components: {
    Header,
    RenderDeleteModal,
    RenderSpinner,
  },
  mounted() {
    this.fetchBannerGroups();
  },
  data: function() {
    return {
      fields: [
        {
          key: 'id',
          label: this.$t('ID'),
          sortable: true,
        },
        {
          key: 'name',
          label: this.$t('NAME'),
          sortable: true,
        },
        {
          key: 'description',
          label: this.$t('BANNER_GROUP_DESCRIPTION'),
          sortable: false,
        },
        {
          key: 'bannerCount',
          label: this.$t('BANNERS'),
          sortable: false,
        },
        {
          key: 'formattedModifiedDtime',
          label: this.$t('MODIFIED'),
          sortable: true,
        },
        {
          key: 'actions',
          label: this.$t('ACTIONS'),
          sortable: false,
        },
      ],
      bannerGroups: [],
      showDeleteModal: false,
      selectedBannerGroup: 0,
    };
  },
  methods: {
    fetchBannerGroups() {
      this.$store
        .dispatch('getBannerGroups')
        .then(response => {
          this.bannerGroups = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    openDeleteModal(id) {
      this.showDeleteModal = true;
      this.selectedBannerGroup = id;
    },
    closeDeleteModal(doDelete) {
      this.showDeleteModal = false;
      if (doDelete) {
        this.$store
          .dispatch('deleteBannerGroup', this.selectedBannerGroup)
          .then(() => {
            this.selectedBannerGroup = 0;
            this.fetchBannerGroups();
          });
      }
    },
  },
  computed: {
    ...mapState(['loading']),
    role() {
      return window.localStorage.getItem('role');
    },
  },
};
</script>
